module.exports = __webpack_public_path__ + "img/strategy_contract_grey.0b0e59fe.svg";